<div id="tender-dashboard" class="container-fluid mt-5">
  <div class="card mb-3">

    <div class="row align-items-center">
      <div class="col d-flex flex-row align-items-center min-height border-bottom">
        <h1 class="page-title mx-3">
          <jft-time-remaining [round]="round"></jft-time-remaining>
        </h1>
        <jft-round-status [status]="round.status"></jft-round-status>
        <ul class="nav nav-links ms-6">
          <jft-round-controls [tender]="tender" [round]="round" (onRoundChange)="roundChanged($event)" [rounds]="rounds"
            [contract]="contract" [isSubmittedBid]="isSubmittedBid()" [suppliersCount]="suppliers.length">
          </jft-round-controls>
        </ul>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table bg-transparent mb-0">
        <thead>
          <tr>
            <th class="border-bottom">Supplier</th>
            <th class="border-bottom">Offer</th>
            <th class="border-bottom">Price Base</th>
            <th class="border-bottom">Delivery Point</th>
            <th class="border-bottom">Differential</th>
            <th class="border-bottom">Payment Terms</th>
            <th class="border-bottom">Comment</th>
            <th class="border-bottom" *ngIf="round.status != roundStatuses.AWAITING_REVIEW" class="text-center">Status
            </th>
            <th class="border-bottom">
              <div class="th"></div>
            </th>
            <th class="border-bottom">
              <div class="th"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let offer of suppliers; let index = index;">
            <td>
              <div class="td d-flex align-items-center">
                <div *ngIf="offer.supplier.logo" class="avatar avatar-48 bg-white shadow me-3">
                  <img class="p-2" src="{{ offer.supplier.logo }}" alt="{{ offer.supplier.name }}">
                </div>
                <div *ngIf="!offer.supplier.logo" class="avatar avatar-48 bg-white shadow me-3 p-2">
                  <svg fill="#c6c9d2" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 60" xml:space="preserve"
                    stroke="#c6c9d2">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <path
                          d="M58,37.104V4c0-0.553-0.448-1-1-1H1C0.448,3,0,3.447,0,4v44c0,0.553,0.448,1,1,1h34.003c1.963,4.693,6.6,8,11.997,8 c7.168,0,13-5.832,13-13C60,41.465,59.26,39.105,58,37.104z M34.359,47H2V5h54v29.622c-0.17-0.164-0.354-0.311-0.532-0.465 c-0.088-0.075-0.171-0.155-0.261-0.228c-0.235-0.192-0.48-0.37-0.728-0.545c-0.092-0.065-0.181-0.135-0.275-0.198 c-0.245-0.163-0.498-0.312-0.754-0.458c-0.109-0.063-0.214-0.13-0.325-0.189c-0.077-0.041-0.154-0.083-0.232-0.123 c0.179-0.385,0.112-0.852-0.218-1.154l-12-11c-0.196-0.179-0.452-0.277-0.72-0.262c-0.265,0.012-0.515,0.129-0.694,0.325 l-9.794,10.727l-4.743-4.743c-0.374-0.373-0.972-0.391-1.368-0.044L6.339,41.249c-0.415,0.365-0.455,0.997-0.09,1.412 C6.447,42.886,6.723,43,7,43c0.234,0,0.47-0.082,0.66-0.249l16.313-14.362l10.302,10.301c0.203,0.203,0.47,0.295,0.736,0.287 C34.361,40.523,34,42.22,34,44c0,0.493,0.033,0.977,0.087,1.456c0.009,0.075,0.024,0.149,0.034,0.224 c0.056,0.428,0.131,0.849,0.227,1.262C34.353,46.961,34.354,46.981,34.359,47z M48.779,31.136 c-0.162-0.022-0.321-0.055-0.485-0.071C47.867,31.023,47.435,31,47,31c-4.773,0-8.942,2.593-11.203,6.437 c-0.036-0.054-0.06-0.114-0.107-0.162l-4.807-4.807l9.181-10.054l9.694,8.887c-0.067-0.015-0.133-0.032-0.2-0.045 C49.301,31.204,49.039,31.172,48.779,31.136z M47,55c-4.787,0-8.859-3.08-10.367-7.358c-0.094-0.267-0.176-0.536-0.249-0.806 c-0.015-0.058-0.03-0.115-0.045-0.173c-0.06-0.238-0.112-0.476-0.156-0.716c-0.024-0.133-0.042-0.267-0.061-0.401 c-0.026-0.18-0.054-0.36-0.071-0.54C36.021,44.674,36,44.339,36,44c0-6.065,4.935-11,11-11c0.426,0,0.848,0.031,1.265,0.079 c0.127,0.015,0.25,0.039,0.375,0.057c0.291,0.044,0.579,0.096,0.863,0.162c0.141,0.033,0.281,0.07,0.421,0.108 c0.268,0.074,0.531,0.159,0.792,0.253c0.134,0.048,0.269,0.094,0.4,0.147c0.295,0.119,0.583,0.255,0.866,0.399 c0.083,0.042,0.17,0.077,0.252,0.121c0.342,0.185,0.671,0.393,0.992,0.614c0.131,0.09,0.255,0.19,0.382,0.286 c0.199,0.15,0.395,0.305,0.584,0.469c0.127,0.11,0.251,0.224,0.373,0.339c0.193,0.184,0.379,0.377,0.559,0.575 c0.094,0.103,0.191,0.202,0.281,0.309c0.261,0.311,0.51,0.634,0.739,0.976C57.315,39.643,58,41.743,58,44 C58,50.065,53.065,55,47,55z">
                        </path>
                        <path
                          d="M51.95,39.051c-0.391-0.391-1.023-0.391-1.414,0L47,42.586l-3.536-3.535c-0.391-0.391-1.023-0.391-1.414,0 s-0.391,1.023,0,1.414L45.586,44l-3.536,3.535c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293 s0.512-0.098,0.707-0.293L47,45.414l3.536,3.535c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293 c0.391-0.391,0.391-1.023,0-1.414L48.414,44l3.536-3.535C52.34,40.074,52.34,39.441,51.95,39.051z">
                        </path>
                        <path
                          d="M16,25.138c3.071,0,5.569-2.498,5.569-5.568C21.569,16.498,19.071,14,16,14s-5.569,2.498-5.569,5.569 C10.431,22.64,12.929,25.138,16,25.138z M16,16c1.968,0,3.569,1.602,3.569,3.569S17.968,23.138,16,23.138s-3.569-1.601-3.569-3.568 S14.032,16,16,16z">
                        </path>
                      </g>
                    </g>
                  </svg>
                </div>
                {{offer.supplier.name}} <span *ngIf="offer.supplier.supplierAlias"
                  class="text-muted">({{offer.supplier.supplierAlias}})</span>
              </div>
            </td>
            <td>
              {{ offer.name }}
            </td>

            <ng-template [ngIf]="awaitingOfferStatuses.includes(offer.status)">
              <td colspan="8">
                <div class="td d-flex align-items-center">
                  Awaiting offer from supplier
                </div>
              </td>
            </ng-template>
            <ng-template [ngIf]="[offerStatuses.DECLINED].includes(offer.status)">
              <td colspan="8">
                <div class="td d-flex align-items-center">
                  Supplier will not be submitting a bid at this location
                </div>
              </td>
            </ng-template>
            <ng-template [ngIf]="offer.status == offerStatuses.EXPIRED">
              <td colspan="8">
                <div class="td d-flex align-items-center">
                  Round time ended, no bids received
                </div>
              </td>
            </ng-template>

            <ng-template
              [ngIf]="[offerStatuses.RECEIVED, offerStatuses.AWARDED, offerStatuses.DECLINED_SUBMITTED].includes(offer.status)">
              <td>
                <span *ngIf="offer.bid.marketPrice && offer.bid.marketPrice.price">
                  {{tender.company.settings.getFieldName('market_price', 'Market price')}}
                  {{offer.bid.marketPrice.price.price.value |
                  numberMoney:offer.bid.marketPrice.price.price.currency.code}}
                  {{offer.bid.marketPrice.price.price.currency.code}}
                  {{offer.bid.marketPrice.price.units.code}}
                </span>
                <span *ngIf="offer.bid.index">
                  <span [ngbTooltip]="indexTooltip">
                    Index price
                    {{offer.bid.index.index_code.provider}}
                    {{tender.company.settings.getFilteredOptionLabel('index', offer.bid.index.index_code)}}
                    {{tender.company.settings.getFilteredOptionLabel('averaging_method',
                    $safeNavigationMigration(offer.bid.index?.averaging_method))}} {{offer.bid.index.averaging_offset?.name}}
                    {{offer.bid.index.effective_day?.name}}
                  </span>
                  <ng-template #indexTooltip>
                    <div class="text-start">
                      <p class="mb-0">Index price
                        {{offer.bid.index.index_code.provider}}
                        {{tender.company.settings.getFilteredOptionLabel('index', offer.bid.index.index_code)}}
                        {{tender.company.settings.getFilteredOptionLabel('averaging_method',
                        $safeNavigationMigration(offer.bid.index?.averaging_method))}} {{offer.bid.index.averaging_offset?.name}}
                        {{offer.bid.index.vata_applicability}}
                      </p>
                    </div>
                  </ng-template>
                </span>
              </td>
              <td>
                {{tender.company.settings.getFilteredOptionLabel('delivery_point', $safeNavigationMigration(offer.bid?.fuelPreference))}}
              </td>
              <td>
                {{offer.bid.differential?.getLabel()}}
              </td>
              <td>
                <span *ngIf="offer.bid.isPaymentPrepayment()">
                  Prepayment,
                  Days Prepaid: {{offer.bid.payment.prepayment?.number_days_prepaid}},
                  Invoice Frequency: {{offer.bid.payment.prepayment.payment_frequency?.name}}
                </span>
                <span *ngIf="offer.bid.isPaymentOpenInvoice()">
                  {{tender.company.settings.getFieldName('open_invoice', 'Open Invoice')}}
                  , Payment Terms: {{offer.bid.payment.open_invoice.payment_terms}},
                  Invoice Frequency: {{offer.bid.payment.invoice_frequency?.name}}
                </span>
              </td>
              <td>
                <jft-award-comment-icon [comment]="offer.awardComment"
                  [airline]="$safeNavigationMigration(tender?.company?.name)"></jft-award-comment-icon>
                <span *ngIf="!offer.awardComment" class="text-muted">-</span>
              </td>
              <td *ngIf="round.status != roundStatuses.AWAITING_REVIEW">
                <jft-offer-status [signature]="offer.bid.signature" [status]="offer.status"
                  [awardedPercent]="offer.awardedPercent">
                </jft-offer-status>
              </td>
              <td class="text-end">
                <a *ngIf="offer.bid && offer.status != offerStatuses.AWARDED"
                  [routerLink]="['/tenders',tender.id,'locations',contract.id,'dashboard', 'rounds', round.round, 'suppliers', offer.id]">
                  <span>Details</span>
                </a>
                <a *ngIf="offer.bid && offer.status == offerStatuses.AWARDED"
                  [routerLink]="['/tenders',tender.id,'locations',contract.id,'dashboard', 'rounds', round.round, 'suppliers', offer.id, 'awarded']">
                  <span>Details</span>
                </a>
              </td>
              <td class="text-end">
                <div *ngIf="round.round != lastRound.round && user.canManage(tender)">
                  <button class="btn btn-outline-primary ms-2" placement="left" [popoverTitle]="'Move to Current Round'"
                    [autoClose]="true" #p="ngbPopover" [ngbPopover]="moveToRound">
                    Move
                  </button>
                  <ng-template #moveToRound>
                    <button (click)="p.close()" class="btn btn-light w-100">
                      Cancel
                    </button>
                    <button (click)="moveToCurrentRound(offer)" class="btn btn-outline-primary w-100">
                      Move to Current Round
                    </button>
                  </ng-template>
                </div>
              </td>
            </ng-template>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>